import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Social from '../common/Social';
import 'lazysizes';
import 'lazysizes/plugins/attrchange/ls.attrchange';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import 'lazysizes/plugins/aspectratio/ls.aspectratio';

// TODO Map content paragraphs

const Box = styled.div`
  div {
    height: calc(100vw * 1);
    max-height: calc(100vw * 1);
    width: 100%;
    max-width: 599px;
    border: none;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-content: center;
  }
  @media (min-width: 600px) {
    div {
      height: calc((100vw * 0.5));
      max-height: 950px;
      width: calc(100vw * 0.5);
      max-width: 950px;
      overflow: hidden;
    }
    div:nth-child(1) {
      order: 1;
    }
    div:nth-child(2) {
      order: 2;
    }
    div:nth-child(3) {
      order: 4;
    }
    div:nth-child(4) {
      order: 3;
    }
    div:nth-child(5) {
      order: 5;
    }
    div:nth-child(6) {
      order: 6;
    }
    div:nth-child(7) {
      order: 8;
    }
    div:nth-child(8) {
      order: 7;
    }
    div:nth-child(9) {
      order: 9;
    }
    div:nth-child(10) {
      order: 10;
    }
    div:nth-child(11) {
      order: 12;
    }
    div:nth-child(12) {
      order: 11;
    }
    div:nth-child(13) {
      order: 13;
    }
    div:nth-child(14) {
      order: 14;
    }
  }
  h3 {
    font-size: 1.6rem;
  }
  a {
    color: rgba(255, 255, 255, 0.9);
    padding: 1px 3px;
  }
  a:hover {
    border: 1px dotted #fff;
    padding: 0 2px;
    color: rgba(255, 255, 255, 1);
    text-decoration: none;
  }

  p {
    font-size: 1.2rem;
    margin: 0;
  }
  @media (min-width: 400px) {
    h3 {
      font-size: 2rem;
    }
    p {
      font-size: 1.4rem;
    }
  }

  @media (min-width: 601px) and (max-width: 719px) {
    h3 {
      font-size: 1.3rem;
    }
    p {
      font-size: 1rem;
      line-height: 1.3;
    }
  }
  @media (min-width: 720px) and (max-width: 1200px) {
    h3 {
      font-size: 1.4rem;
    }
    p {
      font-size: 1.2rem;
      line-height: 1.4;
    }
  }
  @media (min-width: 1201px) {
    h3 {
      font-size: 1.5rem;
    }
    p {
      font-size: 1.4rem;
      line-height: 1.5;
    }
  }
`;

export default function GiftsBlock({ className = '', ...props }) {
  const classNames = ['uk-flex uk-flex-row uk-flex-wrap', className].join(' ');

  const gifts = props.gifts;

  const Items = gifts.map((c) => (
    <React.Fragment key={c.name}>
      <div className="uk-background-primary">
        <img
          className="lazyload"
          type="image/jpg"
          data-sizes="auto"
          data-srcset={`
            ${c.imgXs} ${c.wDescXs}w,
            ${c.imgSm} ${c.wDescSm}w,
            ${c.imgMd} ${c.wDescMd}w,
            ${c.imgLg} ${c.wDescLg}w,
            `}
          data-aspectration={c.aspectratio}
          data-src={c.imgLg}
          alt={c.alt}
        />
      </div>
      <div
        className={`uk-background-${c.bgColor} uk-light uk-flex uk-flex-center
uk-flex-middle uk-text-center`}
      >
        <div
          className="uk-padding  uk-flex uk-flex-center
uk-flex-middle uk-text-center"
          data-uk-scrollspy={`cls: uk-animation-slide-${c.direction}-medium; delay: 0; repeat: true`}
        >
          <h3>{c.h3}</h3>
          <p>{c.content1}</p>
          <p>{c.content2}</p>
          <Promo
            promoUrl={c.promoUrl}
            promoText={c.promoText}
            promoIcon={c.promoIcon}
            promoAria={c.promoAria}
          />
        </div>
      </div>
    </React.Fragment>
  ));
  return <Box className={classNames}>{Items}</Box>;
}

function Promo({ promoUrl, promoText, promoIcon, promoAria }) {
  if (!promoText) {
    return null;
  }

  return (
    <p className="uk-margin-top">
      <a href={promoUrl}>{promoText}</a> <Social url={promoUrl} icon={promoIcon} aria={promoAria} />
    </p>
  );
}
GiftsBlock.defaultProps = {
  gifts: [],
};
GiftsBlock.propTypes = {
  name: PropTypes.string,
  gifts: PropTypes.array,
  className: PropTypes.string,
  bgColor: PropTypes.string,
  direction: PropTypes.string,
  h3: PropTypes.string,
  content1: PropTypes.string,
  content2: PropTypes.string,
  aspectratio: PropTypes.number,
  wDescXs: PropTypes.number,
  wDescSm: PropTypes.number,
  wDescMd: PropTypes.number,
  wDescLg: PropTypes.number,
  imgXs: PropTypes.string,
  imgSm: PropTypes.string,
  imgMd: PropTypes.string,
  imgLg: PropTypes.string,
  alt: PropTypes.string,
  promoUrl: PropTypes.string,
  promoIcon: PropTypes.string,
  promoText: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/features/gifts/GiftsBlock.js